import React, {useEffect, useRef, useState} from 'react';

import DetailNavTitle from '@businessComponents/detail-nav-title';
import {goBack, goTo} from '@/utils';

import globalStore from '@/services/global.state';
import {useTranslation} from 'react-i18next';
import VipCardListV2, {VipCardListV2Ref} from './vip-card-list-v2';
import AspectRatio from '@/components/basic/aspect-ratio';
import {VipConfigVO} from './vip.service';

import VipPrizeDetail from './vip-prize-detail';
import PageReceiveButton from './components/page-receive-button';

const Vip = () => {
  const {i18n} = useTranslation();
  const [login, setLogin] = useState(!!globalStore.token);

  useEffect(() => {
    const sub = globalStore.tokenSubject.subscribe(token => {
      setLogin(!!token);
    });
    return () => sub.unsubscribe();
  }, []);
  const [vip, setVip] = useState<VipConfigVO>({});
  const toWeekCard = () => {
    goTo('WeekCard');
  };

  const vipCardListRef = useRef<VipCardListV2Ref>(null);
  const onRefresh = () => {
    vipCardListRef.current?.refresh();
  };

  return (
    <div className="flex flex-col w-[23.4375rem] h-full fixed top-0 left-1/2 -translate-x-1/2 bg-bg">
      <DetailNavTitle
        title={i18n.t('vip.title')}
        onBack={() => goBack()}
        hideServer
        hideAmount
      />
      <div className="flex flex-col gap-2 flex-1 pt-3 overflow-hidden">
        <VipCardListV2
          ref={vipCardListRef}
          login={login}
          onCardChange={setVip}
        />
        {false && (
          <AspectRatio
            ratio={351 / 77}
            className="px-3 rounded-lg"
            onClick={toWeekCard}>
            <div
              className="w-full h-full bg-cover bg-no-repeat"
              style={{
                backgroundImage: `url(${require('@/assets/imgs/vip/banner.webp')})`,
              }}
            />
          </AspectRatio>
        )}
        <VipPrizeDetail vip={vip} />
        <PageReceiveButton vip={vip} onRefresh={onRefresh} />
      </div>
    </div>
  );
};

export default Vip;
